import globalPostFields from '@/lib/wp/_partials/globalPostFields';
import featuredImageFields from '@/lib/wp/media/featuredImage';
import defaultPageData from '@/lib/wp/_partials/defaultPageData';
import seoPostFields from '@/lib/wp/_partials/seoPostFields';
import { gql } from '@apollo/client';

export const singlePageFragment = gql`
  fragment SinglePageFields on Page {
    ${globalPostFields}
    blocksJSON
    excerpt
    ${featuredImageFields}
    ${seoPostFields}
  }
`;

const queryPageById = gql`
  query GET_PAGE_BY_ID($id: ID!, $idType: PageIdType = URI, $imageSize: MediaItemSizeEnum = LARGE) {
    ${defaultPageData}
    page(id: $id, idType: $idType) {
      ...SinglePageFields
      isPostsPage
    }
  }
  ${singlePageFragment}
`;

export default queryPageById;
